export enum FILTER_POLICY {
    BY_INSURED = 0,
    BY_BRANCH_AND_POLICY_NUMBER = 1,
    BY_LICENCE_PLATE = 2
}